// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Loaded with the shop bundle: sanitized AJAX dialogs do not retain inline style blocks. */
.photo-change-modal .select-photo-image-button .photo-in-list {
    height: 150px;
    object-fit: contain;
}

.photo-change-modal .select-photo-image-button {
    background: transparent;
    border: none;
    cursor: pointer;
}

.photo-change-modal .select-photo-image-button.selected-image {
    border: 3px solid var(--success-color, var(--bs-success));
    border-radius: 5px;
}

/* Include phones rotated into landscape, even when wider than the mobile breakpoint. */
@media (max-width: 767.98px), (orientation: landscape) and (max-height: 600px) and (pointer: coarse) {
    .modal.photo-change-modal .modal-dialog {
        width: 100%;
        max-width: none;
        height: 100%;
        height: 100dvh;
        min-height: 0;
        margin: 0;
    }





    .modal.photo-change-modal .modal-content {
        height: 100%;
        max-height: 100%;
        border: 0;
        border-radius: 0;
        overflow: hidden;
        padding-top: env(safe-area-inset-top);
        padding-right: env(safe-area-inset-right);
        padding-bottom: env(safe-area-inset-bottom);
        padding-left: env(safe-area-inset-left);
    }

    .modal.photo-change-modal .modal-body {
        min-height: 0;
        max-height: none;
        overflow-y: auto;
    }

    /* Size each choice to the space remaining below the header and above the footer. */
    .modal.photo-change-modal .modal-body {
        container-type: size;
        scroll-snap-type: y proximity;
    }

    .modal.photo-change-modal .photo-selection-gallery {
        display: grid !important;
        grid-template-columns: minmax(0, 1fr);
        grid-auto-rows: 100cqh;
        gap: 0.5rem;
        width: 100%;
        min-width: 0;
    }

    .modal.photo-change-modal .photo-selection-gallery .photo-in-list-button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        min-width: 0;
        min-height: 0;
        scroll-snap-align: start;
    }

    .modal.photo-change-modal .photo-selection-gallery .photo-in-list {
        width: 100%;
        height: 100%;
        min-height: 0;
        margin: 0 !important;
        object-fit: contain;
    }

    .modal.photo-change-modal .combined-edit-modal-body {
        flex-direction: column;
    }

    .modal.photo-change-modal .combined-edit-modal-select-column,
    .modal.photo-change-modal .combined-edit-modal-crop-column {
        flex: 0 0 auto;
        min-width: 0;
        max-width: 100%;
    }

    .modal.photo-change-modal .combined-edit-modal-divider {
        display: none;
    }

    /* Product details must not push the close button beyond the narrow viewport. */
    .modal.photo-change-modal .combined-edit-modal-dialog .modal-header {
        display: grid;
        grid-template-columns: minmax(0, 1fr) auto;
        gap: 0.5rem;
    }

    .modal.photo-change-modal .combined-edit-modal-dialog .modal-header > .d-flex {
        display: contents !important;
    }

    .modal.photo-change-modal .combined-edit-modal-header-info {
        grid-column: 1 / -1;
        grid-row: 2;
        flex-wrap: wrap;
    }

    .modal.photo-change-modal .combined-edit-modal-dialog .modal-header .btn-close {
        grid-column: 2;
        grid-row: 1;
    }
}

/* Swipe one full-size choice at a time when the phone is turned sideways. */
@media (orientation: landscape) and (max-width: 767.98px),
       (orientation: landscape) and (max-height: 600px) and (pointer: coarse) {




    .modal.photo-change-modal .photo-selection-gallery {
        grid-template-columns: none;
        grid-template-rows: 100%;
        grid-auto-flow: column;
        grid-auto-columns: 100%;
        grid-auto-rows: auto;
        height: 100cqh;
        overflow-x: auto;
        overflow-y: hidden;
        scroll-snap-type: x mandatory;
        overscroll-behavior-x: contain;
    }
}
`, "",{"version":3,"sources":["webpack://./Areas/Shop/Client/css/photo-change-modal.css"],"names":[],"mappings":"AAAA,2FAA2F;AAC3F;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yDAAyD;IACzD,kBAAkB;AACtB;;AAEA,uFAAuF;AACvF;IACI;QACI,WAAW;QACX,eAAe;QACf,YAAY;QACZ,cAAc;QACd,aAAa;QACb,SAAS;IACb;;;;;;IAMA;QACI,YAAY;QACZ,gBAAgB;QAChB,SAAS;QACT,gBAAgB;QAChB,gBAAgB;QAChB,qCAAqC;QACrC,yCAAyC;QACzC,2CAA2C;QAC3C,uCAAuC;IAC3C;;IAEA;QACI,aAAa;QACb,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA,mFAAmF;IACnF;QACI,oBAAoB;QACpB,6BAA6B;IACjC;;IAEA;QACI,wBAAwB;QACxB,qCAAqC;QACrC,sBAAsB;QACtB,WAAW;QACX,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,aAAa;QACb,wBAAwB;IAC5B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,oBAAoB;QACpB,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,cAAc;QACd,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA,+EAA+E;IAC/E;QACI,aAAa;QACb,0CAA0C;QAC1C,WAAW;IACf;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,mBAAmB;QACnB,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;AACJ;;AAEA,4EAA4E;AAC5E;;;;;;IAMI;QACI,2BAA2B;QAC3B,wBAAwB;QACxB,sBAAsB;QACtB,uBAAuB;QACvB,oBAAoB;QACpB,cAAc;QACd,gBAAgB;QAChB,kBAAkB;QAClB,6BAA6B;QAC7B,8BAA8B;IAClC;AACJ","sourcesContent":["/* Loaded with the shop bundle: sanitized AJAX dialogs do not retain inline style blocks. */\n.photo-change-modal .select-photo-image-button .photo-in-list {\n    height: 150px;\n    object-fit: contain;\n}\n\n.photo-change-modal .select-photo-image-button {\n    background: transparent;\n    border: none;\n    cursor: pointer;\n}\n\n.photo-change-modal .select-photo-image-button.selected-image {\n    border: 3px solid var(--success-color, var(--bs-success));\n    border-radius: 5px;\n}\n\n/* Include phones rotated into landscape, even when wider than the mobile breakpoint. */\n@media (max-width: 767.98px), (orientation: landscape) and (max-height: 600px) and (pointer: coarse) {\n    .modal.photo-change-modal .modal-dialog {\n        width: 100%;\n        max-width: none;\n        height: 100%;\n        height: 100dvh;\n        min-height: 0;\n        margin: 0;\n    }\n\n\n\n\n\n    .modal.photo-change-modal .modal-content {\n        height: 100%;\n        max-height: 100%;\n        border: 0;\n        border-radius: 0;\n        overflow: hidden;\n        padding-top: env(safe-area-inset-top);\n        padding-right: env(safe-area-inset-right);\n        padding-bottom: env(safe-area-inset-bottom);\n        padding-left: env(safe-area-inset-left);\n    }\n\n    .modal.photo-change-modal .modal-body {\n        min-height: 0;\n        max-height: none;\n        overflow-y: auto;\n    }\n\n    /* Size each choice to the space remaining below the header and above the footer. */\n    .modal.photo-change-modal .modal-body {\n        container-type: size;\n        scroll-snap-type: y proximity;\n    }\n\n    .modal.photo-change-modal .photo-selection-gallery {\n        display: grid !important;\n        grid-template-columns: minmax(0, 1fr);\n        grid-auto-rows: 100cqh;\n        gap: 0.5rem;\n        width: 100%;\n        min-width: 0;\n    }\n\n    .modal.photo-change-modal .photo-selection-gallery .photo-in-list-button {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 100%;\n        height: 100%;\n        min-width: 0;\n        min-height: 0;\n        scroll-snap-align: start;\n    }\n\n    .modal.photo-change-modal .photo-selection-gallery .photo-in-list {\n        width: 100%;\n        height: 100%;\n        min-height: 0;\n        margin: 0 !important;\n        object-fit: contain;\n    }\n\n    .modal.photo-change-modal .combined-edit-modal-body {\n        flex-direction: column;\n    }\n\n    .modal.photo-change-modal .combined-edit-modal-select-column,\n    .modal.photo-change-modal .combined-edit-modal-crop-column {\n        flex: 0 0 auto;\n        min-width: 0;\n        max-width: 100%;\n    }\n\n    .modal.photo-change-modal .combined-edit-modal-divider {\n        display: none;\n    }\n\n    /* Product details must not push the close button beyond the narrow viewport. */\n    .modal.photo-change-modal .combined-edit-modal-dialog .modal-header {\n        display: grid;\n        grid-template-columns: minmax(0, 1fr) auto;\n        gap: 0.5rem;\n    }\n\n    .modal.photo-change-modal .combined-edit-modal-dialog .modal-header > .d-flex {\n        display: contents !important;\n    }\n\n    .modal.photo-change-modal .combined-edit-modal-header-info {\n        grid-column: 1 / -1;\n        grid-row: 2;\n        flex-wrap: wrap;\n    }\n\n    .modal.photo-change-modal .combined-edit-modal-dialog .modal-header .btn-close {\n        grid-column: 2;\n        grid-row: 1;\n    }\n}\n\n/* Swipe one full-size choice at a time when the phone is turned sideways. */\n@media (orientation: landscape) and (max-width: 767.98px),\n       (orientation: landscape) and (max-height: 600px) and (pointer: coarse) {\n\n\n\n\n    .modal.photo-change-modal .photo-selection-gallery {\n        grid-template-columns: none;\n        grid-template-rows: 100%;\n        grid-auto-flow: column;\n        grid-auto-columns: 100%;\n        grid-auto-rows: auto;\n        height: 100cqh;\n        overflow-x: auto;\n        overflow-y: hidden;\n        scroll-snap-type: x mandatory;\n        overscroll-behavior-x: contain;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
